import { render, staticRenderFns } from "./equipmentStatistics.vue?vue&type=template&id=5221bbc9&scoped=true&"
import script from "./equipmentStatistics.vue?vue&type=script&lang=js&"
export * from "./equipmentStatistics.vue?vue&type=script&lang=js&"
import style0 from "./equipmentStatistics.vue?vue&type=style&index=0&id=5221bbc9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5221bbc9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5221bbc9')) {
      api.createRecord('5221bbc9', component.options)
    } else {
      api.reload('5221bbc9', component.options)
    }
    module.hot.accept("./equipmentStatistics.vue?vue&type=template&id=5221bbc9&scoped=true&", function () {
      api.rerender('5221bbc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newDashboard/components/equipmentStatistics.vue"
export default component.exports